import React from 'react'
import { sample } from 'lodash'
import { ModalBody, ModalHeader, Modal, Button } from 'reactstrap'

export default function SampleDocCards(props) {
  const close = () => {
    props.close('isOpen')
  }

  return (
    <Modal isOpen={props.isOpen}
      toggle={close}
      className="modal-md">
      <ModalHeader toggle={close}>
      </ModalHeader>
      <ModalBody className="sample-container">
        <div className="d-flex flex-column p-2">
          <div className="p-2 font-size-20  font-weight-semi-bold">
            {props.sampleData.title}
          </div>
          <div className="p-2 font-size-14">
            {props.sampleData.text}
          </div>
          {
            props.sampleData.isVideo ?
              <video className="img img-fluid" src={props.sampleData.img} controls autoPlay />
              :
              <img className={props.sampleData.isBank ? "img img-fluid img-bank" : "img img-fluid img-max"} alt="" src={props.sampleData.img} />
          }
          <div className="dos-donts font-size-14">
            {
              props.sampleData.points.map(item => (
                <div className="row py-2">
                  <div >
                    {
                      item.isCorrect ?
                        <span style={{ color: "green" }} class="mdi mdi-check greenIcon dataControl">&nbsp;&nbsp;</span> :
                        <span style={{ color: "red" }} class="mdi pr-2">&nbsp;x&nbsp;</span>
                    }
                  </div>
                  <div className="col-10">
                    {item.text}
                  </div>
                </div>
              ))
            }
          </div>
          <Button onClick={close} color="primary">OK</Button>
        </div>
      </ModalBody>
    </Modal>

  )
}
